/**
 * YellowDot — pulsing yellow accent dot placed before section headings.
 * Creates the signature visual motif as users scroll through the marketing homepage.
 */

import React from 'react';
import { cn } from '@/lib/utils/utils';

interface YellowDotProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: 'w-2 h-2',
  md: 'w-2.5 h-2.5',
  lg: 'w-3 h-3'
};

export function YellowDot({ size = 'md', className }: YellowDotProps) {
  return (
    <span
      className={cn('mktg-pulse-dot', sizeMap[size], className)}
      aria-hidden='true'
    />
  );
}
